import { extractStringValueSet } from './extract-properties';

export default class OrderUrgency {

    static readonly VIP: string = 'vip';
    static readonly Stat: string = 'stat';
    static readonly VeryHigh: string = 'very-high';
    static readonly High: string = 'high';
    static readonly Medium: string = 'medium';
    static readonly Low: string = 'low';
    static readonly VeryLow: string = 'very-low';

    /**
  * @deprecated as of v2.5.0
  */
    static readonly Normal: string = 'normal';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
